export class DiagramInfo {
    diagramType: string;
    diagramId: string;
    clampId: string;
    pressureClassId: string;
    pipesizeId: string;
    flangeTypeId: string;
    flangeFacingTypeId: string;
    gasketTypeId: string;
    name: string;
    noOfBolts: number;
    boltType: string;
}
